const CheckboxChecked = (props) => {
  return (
	<svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x="0.5" y="1" width="19" height="19" rx="3.5" fill="white"/>
		<rect x="0.5" y="1" width="19" height="19" rx="3.5" stroke="#666666"/>
		<path d="M15.0785 6L7.71913 13.3594L4.92151 10.5617L4 11.4832L7.71913 15.2024L16 6.92151L15.0785 6Z" fill="currentColor"/>
	</svg>
  );
};

export default CheckboxChecked;